import React from "react";
import { Input, Button, Typography } from "../../core";
import { Form } from "antd";
import { UserOutlined, KeyOutlined, MailOutlined } from "@ant-design/icons";
const layout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
};
const btnProps = {
  width: "187px",
  bg: "#404E67",
  type: "primary",
  htmlType: "submit",
};
const typoProps = {
  align: "center",
  as: "h3",
  weight: "600",
  color: "white",
};
const AddUser = ({ form, isEdit, ...props }) => {
  const onFinish = (values) => {
    props.onCreate(values);
    form.resetFields();
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  return (
    <Form
      form={form}
      {...layout}
      name="basic"
      initialValues={{
        remember: true,
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      // onValuesChange={onValuesChange}
    >
      <Form.Item
        label=""
        name="username"
        rules={[
          {
            required: true,
            message: "Please input User Name!",
          },
        ]}
      >
        <Input prefix={<UserOutlined />} placeholder="User name" />
      </Form.Item>

      <Form.Item
        label=""
        name="email"
        rules={[
          {
            required: true,
            message: "Please input Email!",
          },
        ]}
      >
        <Input prefix={<MailOutlined />} placeholder="Email" />
      </Form.Item>
      <Form.Item
        label=""
        name="password"
        rules={[
          {
            required: !isEdit,
            message: "Please input User Password",
          },
        ]}
      >
        <Input
          prefix={<KeyOutlined />}
          placeholder={isEdit ? "New password (optional)" : "Password"}
        />
      </Form.Item>
      <Form.Item label="" name="role" initialValue="staff">
        <Input prefix={<UserOutlined />} placeholder="Role (admin, staff)" />
      </Form.Item>
      <Form.Item>
        <Button {...btnProps}>
          <Typography {...typoProps} text={isEdit ? "Update" : "Add"} />
        </Button>
      </Form.Item>
    </Form>
  );
};

export default AddUser;
